import { render } from "./StockTakeDetailsListView.vue?vue&type=template&id=8adf524a"
import script from "./StockTakeDetailsListView.vue?vue&type=script&lang=js"
export * from "./StockTakeDetailsListView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__